import '@rxdi/ui-kit/animation';
import 'carbon-web-components/es/components/dropdown/dropdown.js';
import 'carbon-web-components/es/components/dropdown/dropdown-item.js';
import 'carbon-web-components/es/components/date-picker/date-picker.js';
import 'carbon-web-components/es/components/date-picker/date-picker-input.js';

import { Module } from '@rxdi/core';
import { css } from '@rxdi/lit-html';
import { AccordionItemComponent } from '@rxdi/ui-kit/accordion-item';
import { AlertComponent } from '@rxdi/ui-kit/alert';
import { ButtonComponent } from '@rxdi/ui-kit/button';
import { CardComponent as RXCard } from '@rxdi/ui-kit/card';
import { ModalModule } from '@rxdi/ui-kit/modal';
import { NavModule } from '@rxdi/ui-kit/nav';
import { PaginationComponent } from '@rxdi/ui-kit/pagination';
import { ProgressComponent } from '@rxdi/ui-kit/progress';
import { TabsComponent as RxTabs } from '@rxdi/ui-kit/tabs';
import { RadioGroup } from '@vaadin/radio-group';
import { RadioButton } from '@vaadin/radio-group/vaadin-radio-button';

import { ReactRevealComponent } from './animations/reveal';
import { BootstrapComponent } from './bootstrap/bootstrap.component';
import { CardComponent } from './card/card.component';
import { DiffComponent } from './diff';
import { DropdownComponent } from './dropdown/dropdown.component';
import { CodeMirrorComponent } from './editor/editor.component';
import { FileUploaderComponent } from './file-uploader/file-uploader';
import { GenericNavbarComponent } from './generic-navbar/generic-navbar.component';
import { GridComponent } from './grid/grid.component';
import { HamburgerComponent } from './hamburgers/hamburger.component';
import { IconComponent } from './icon/icon.component';
import { InfoCardComponent } from './info-card/info-card.component';
import { InfoMenuComponent } from './info-card/info-menu.component';
import { InfoHeaderCardComponent } from './info-header-card/info-header-card.component';
import { InformationComponent } from './information/information.component';
import { ModalDialogComponent } from './modal/modal-dialog.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { NotificationIconComponent } from './notification-icon/notification-feed.component';
import { OriginalStyle } from './original/original-style.component';
import { ProfileIconComponent } from './profile-icon/profile-icon.component';
import { RouterLinkComponent } from './router-link/router-link';
import { SearchComponent } from './search/search.component';
import { ShoelaceModule } from './shoelace.module';
import { SpacerComponent } from './spacer/spacer.component';
import { DefaultSpinnerComponent } from './spinners/default-spinner.component';
import { SvgRepoComponent } from './svg-repo/svg-repo';
import { TableComponent } from './table/table';
import { TabsComponent } from './tabs/tabs.component';
import { TailWindComponent } from './tailwind/tailwind.component';
import { WebCli } from './terminal/terminal.component';
import { InputToggleComponent } from './toggle-input';
@Module({
  imports: [
    NavModule.forRoot(),
    ModalModule.forRoot({
      style: css`
        .wrapper {
          position: fixed;
          top: 0;
          left: 0;
          align-items: center;
          justify-content: center;
          pointer-events: none;
          width: 100%;
          height: 100%;
          z-index: 11;
        }

        .backdrop {
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          position: fixed;
          background-color: rgba(0, 0, 0, 0.5);
          pointer-events: all;
          z-index: 10;
        }

        .content {
          z-index: 20;
          position: fixed;
          width: 100%;
          height: 100%;
          pointer-events: all;
        }
      `,
    }),
    ShoelaceModule,
  ],
  components: [
    TailWindComponent,
    DefaultSpinnerComponent,
    OriginalStyle,
    CardComponent,
    ModalDialogComponent,
    HamburgerComponent,
    AccordionItemComponent,
    DropdownComponent,
    InfoCardComponent,
    InfoHeaderCardComponent,
    GenericNavbarComponent,
    TabsComponent,
    BootstrapComponent,
    SpacerComponent,
    GridComponent,
    RouterLinkComponent,
    RxTabs,
    NotificationIconComponent,
    PaginationComponent,
    SearchComponent,
    ButtonComponent,
    RXCard,
    ReactRevealComponent,
    TableComponent,
    InputToggleComponent,
    ProgressComponent,
    FileUploaderComponent,
    InfoMenuComponent,
    ProfileIconComponent,
    WebCli,
    InformationComponent,
    CodeMirrorComponent,
    AlertComponent,
    MultiSelectComponent,
    IconComponent,
    SvgRepoComponent,
    DiffComponent,
    RadioGroup,
    RadioButton,
  ],
})
export class SharedModule {}
